<template>

    <el-alert
        v-if="alreadyexist"
        title="Enquiry Already Exists"
        type="warning"

        show-icon
        effect="dark"
        class="mb-4"
        @click="viewenquiry(alreadyexist.viewlink)"
    >
        <p class="mb-0">Enquiry ID - {{ alreadyexist.id }}</p>
        <p class="mb-0">Name - {{ alreadyexist.name }}</p>
        <p class="mb-0">Phone - {{ alreadyexist.mobile }}</p>
    </el-alert>

    <el-alert
        v-if="addedenquiry"
        title="Enquiry Succesfully Added"
        type="success"
        show-icon
        effect="dark"
        class="mb-4"
        @click="viewenquiry(addedenquiry.viewlink)"
    >
        <p class="mb-0">Enquiry ID - {{ addedenquiry.id }}</p>
        <p class="mb-0">Name - {{ addedenquiry.name }}</p>
        <p class="mb-0">Phone - {{ addedenquiry.mobile }}</p>
    </el-alert>

    <div class="card-box">
        <div class="title">
            <h3>Add Enquiry</h3>
        </div>
        <div class="body">
         <el-form
            label-position="top"
            ref="ruleFormRef"
            :model="form"
            status-icon
            :rules="rules"
        >


            <el-row>
                <el-col :span="24">
                    <el-radio-group v-model="form.type" size="large">
                        <el-radio-button v-for="service in services" :label="service" />
                    </el-radio-group>
                </el-col>
            </el-row>
            <el-row class="mt-2">

                <el-col :span="3">
                    <el-form-item  label="Enquiry Source" prop="enq_source">
                        <el-select v-model="form.enq_source"  placeholder="Select"  style="width:100%" >
                            <el-option
                                v-for="item in sources"
                                :key="item"
                                :label="item"
                                :value="item"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item class="ml-2" label="Name" prop="name">
                        <el-input  v-model="form.name"  placeholder="Enter Name" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item class="ml-2" label="Email Id" prop="email">
                        <el-input  v-model="form.email"  placeholder="Enter Email Id" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item class="ml-2" label="Mobile No." prop="mobile">
                        <CountryPhone v-model="form.mobile" @change="(n) => {
                            form.mobile=n;
                        }" />
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item class="ml-2" label="Adults" prop="adults">
                        <el-input type="number"  v-model="form.adults"  placeholder="Adults" min="0" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item class="ml-2" label="Child" prop="childs">
                        <el-input type="number"  v-model="form.childs"  placeholder="Child" min="0" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item class="ml-2" label="Infants" prop="infants">
                        <el-input type="number"  v-model="form.infants"  placeholder="Infants" min="0" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item class="ml-2" label="Budget" prop="infants">
                        <el-input type="number"  v-model="form.budget"  placeholder="Budget" min="0" ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="form.type=='Package'">
                <el-col :span="6">
                    <el-form-item  label="Source" prop="package.source">
                        <el-input   v-model="form.package.source"  placeholder="Enter Source"  ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item class="ml-2" label="Destinations" prop="package.destinations">
                        <el-select-v2  v-model="form.package.destinations" filterable allow-create  :options="destinations" multiple placeholder="Select"  style="width:100%" >

                        </el-select-v2>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item class="ml-2" label="Destination Type" prop="package.dest_team">
                        <el-select-v2 v-model="form.package.dest_team"   :options="destinationtypes"  placeholder="Select"  style="width:100%" >

                        </el-select-v2>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item class="ml-2" label="Nights" prop="package.nights">
                        <el-input type="number"  v-model="form.package.nights"  placeholder="Nights" min="1" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item class="ml-2" label="Departure Date" prop="package.departure_date">
                        <el-date-picker
                            v-model="form.package.departure_date"
                            type="date"
                            placeholder="Select Date"
                            format="DD MMM YYYY"
                            value-format="YYYY-MM-DD"
                        />

                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item class="ml-2" label="Return Date" prop="package.return_date">
                        <el-date-picker
                            v-model="form.package.return_date"
                            type="date"
                            placeholder="Select Date"
                            format="DD MMM YYYY"
                            value-format="YYYY-MM-DD"
                            disabled
                        />

                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item  label="Services Required" prop="package.packageservices">
                        <el-checkbox-group v-model="form.package.packageservices">
                            <el-checkbox v-for="ser in packageservices" :label="ser" />
                        </el-checkbox-group>


                    </el-form-item>
                </el-col>





            </el-row>
             <el-row v-if="form.type=='Cruise'">
                 <el-col :span="6">
                     <el-form-item  label="Source" prop="common.source">
                         <el-input   v-model="form.common.source"  placeholder="Enter Source"  ></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="6">
                     <el-form-item class="ml-2" label="Destinations" prop="common.destinations">
                         <el-select-v2  v-model="form.common.destinations" filterable allow-create  :options="destinations" multiple placeholder="Select"  style="width:100%" >

                         </el-select-v2>
                     </el-form-item>
                 </el-col>
                 <el-col :span="4">
                     <el-form-item class="ml-2" label="Destination Type" prop="common.dest_team">
                         <el-select-v2 v-model="form.common.dest_team"   :options="destinationtypes"  placeholder="Select"  style="width:100%" >

                         </el-select-v2>
                     </el-form-item>
                 </el-col>
                 <el-col :span="2">
                     <el-form-item class="ml-2" label="Nights" prop="common.nights">
                         <el-input type="number"  v-model="form.common.nights"  placeholder="Nights" min="1" ></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="3">
                     <el-form-item class="ml-2" label="Departure Date" prop="common.departure_date">
                         <el-date-picker
                             v-model="form.common.departure_date"
                             type="date"
                             placeholder="Select Date"
                             format="DD MMM YYYY"
                             value-format="YYYY-MM-DD"
                         />

                     </el-form-item>
                 </el-col>
                 <el-col :span="3">
                     <el-form-item class="ml-2" label="Return Date" prop="common.return_date">
                         <el-date-picker
                             v-model="form.common.return_date"
                             type="date"
                             placeholder="Select Date"
                             format="DD MMM YYYY"
                             value-format="YYYY-MM-DD"
                             disabled
                         />

                     </el-form-item>
                 </el-col>


             </el-row>
             <el-row v-else-if="form.type=='Hotel'">
                 <el-col :span="6">
                     <el-form-item  label="Source" prop="common.source">
                         <el-input   v-model="form.common.source"  placeholder="Enter Source"  ></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="6">
                     <el-form-item class="ml-2" label="Destinations" prop="common.destinations">
                         <el-select-v2 v-model="form.common.destinations" filterable allow-create :options="destinations" multiple placeholder="Select"  style="width:100%" >

                         </el-select-v2>
                     </el-form-item>
                 </el-col>
                 <el-col :span="4">
                     <el-form-item class="ml-2" label="Destination Type" prop="common.dest_team">
                         <el-select-v2 v-model="form.common.dest_team"   :options="destinationtypes"  placeholder="Select"  style="width:100%" >

                         </el-select-v2>
                     </el-form-item>
                 </el-col>
                 <el-col :span="2">
                     <el-form-item class="ml-2" label="Nights" prop="common.nights">
                         <el-input type="number"  v-model="form.common.nights"  placeholder="Nights" min="1" ></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="3">
                     <el-form-item class="ml-2" label="Check-In Date" prop="common.departure_date">
                         <el-date-picker
                             v-model="form.common.departure_date"
                             type="date"
                             placeholder="Select Date"
                             format="DD MMM YYYY"
                             value-format="YYYY-MM-DD"
                         />

                     </el-form-item>
                 </el-col>
                 <el-col :span="3">
                     <el-form-item class="ml-2" label="Check-Out Date" prop="common.return_date">
                         <el-date-picker
                             v-model="form.common.return_date"
                             type="date"
                             placeholder="Select Date"
                             format="DD MMM YYYY"
                             value-format="YYYY-MM-DD"
                             disabled
                         />

                     </el-form-item>
                 </el-col>


             </el-row>
             <el-row v-else-if="form.type=='Flight'">
                 <el-col :span="7">
                     <el-form-item  label="Source" prop="flight.source">
                         <airport-search   v-model="form.flight.source"   ></airport-search>
                     </el-form-item>
                 </el-col>
                 <el-col :span="7">
                     <el-form-item class="ml-2" label="Destination" prop="flight.destinations">
                         <airport-search   v-model="form.flight.destinations"   ></airport-search>

                     </el-form-item>
                 </el-col>
                 <el-col :span="4">
                     <el-form-item class="ml-2" label="Destination Type" prop="flight.dest_team">
                         <el-select-v2 v-model="form.flight.dest_team"   :options="destinationtypes"  placeholder="Select"  style="width:100%" >

                         </el-select-v2>
                     </el-form-item>
                 </el-col>
                 <el-col :span="3">
                     <el-form-item class="ml-2" label="Departure Date" prop="flight.departure_date">
                         <el-date-picker
                             v-model="form.flight.departure_date"
                             type="date"
                             placeholder="Select Date"
                             format="DD MMM YYYY"
                             value-format="YYYY-MM-DD"
                         />

                     </el-form-item>
                 </el-col>
                 <el-col :span="3">
                     <el-form-item class="ml-2" label="Return Date" prop="flight.return_date">
                         <el-date-picker
                             v-model="form.flight.return_date"
                             type="date"
                             placeholder="Select Date"
                             format="DD MMM YYYY"
                             value-format="YYYY-MM-DD"
                                clearable
                         />

                     </el-form-item>
                 </el-col>


             </el-row>
             <el-row v-else-if="form.type=='Visa'">
                 <el-col :span="6">
                     <el-form-item  label="Source" prop="visa.source">
                         <el-input   v-model="form.visa.source"  placeholder="Enter Source"  ></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="6">
                     <el-form-item class="ml-2" label="Destinations" prop="visa.destinations">
                         <el-select-v2 v-model="form.visa.destinations" filterable allow-create :options="destinations" multiple placeholder="Select"  style="width:100%" >

                         </el-select-v2>
                     </el-form-item>
                 </el-col>
                 <el-col :span="4">
                     <el-form-item class="ml-2" label="Destination Type" prop="flight.visa.dest_team">
                         <el-select-v2 v-model="form.visa.dest_team"   :options="destinationtypes"  placeholder="Select"  style="width:100%" >

                         </el-select-v2>
                     </el-form-item>
                 </el-col>
                 <el-col :span="2">
                     <el-form-item class="ml-2" label="Days" prop="visa.nights">
                         <el-input type="number"  v-model="form.visa.nights"  placeholder="Days" min="1" ></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="3">
                     <el-form-item class="ml-2" label="Departure Date" prop="visa.departure_date">
                         <el-date-picker
                             v-model="form.visa.departure_date"
                             type="date"
                             placeholder="Select Date"
                             format="DD MMM YYYY"
                             value-format="YYYY-MM-DD"
                         />

                     </el-form-item>
                 </el-col>
             </el-row>
             <el-row >
                 <el-col :span="24">
                     <el-form-item  label="Specific Requirements" prop="specific_requirements">
                         <el-input type="textarea"  v-model="form.specific_requirements"  ></el-input>
                     </el-form-item>
                 </el-col>

             </el-row>
        </el-form>
        </div>
        <div class="footer">
            <div class="actions">
                <el-button type="primary"  @click="submitForm()" :loading="loading" :disabled="loading">Submit</el-button>

            </div>

        </div>

    </div>

</template>

<script>
import {
    ElCheckboxGroup,ElCheckbox,ElAlert,ElSelectV2,ElRadioGroup,ElRadioButton,ElDialog,ElDropdownMenu,ElDropdown,ElDropdownItem,ElInput,ElText,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,
    ElCard, ElTag,ElDivider,ElSpace, ElPagination, ElCollapseItem, ElCollapse, ElAvatar, ElSkeleton
} from 'element-plus'

import AirportSearch from "../Common/AirportSearch";

import 'element-plus/dist/index.css'
import moment from 'moment'
import CountryPhone from "../Items/CountryPhone.vue";
export default {
    name: "AddEnquiry",
    components: {
        CountryPhone,    ElCheckboxGroup,ElCheckbox,AirportSearch,ElAlert,ElSelectV2,ElRadioGroup,ElRadioButton,ElDialog,ElDropdownMenu,ElDropdown,ElDropdownItem,ElInput,ElText,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,
        ElCard, ElTag,ElDivider,ElSpace, ElPagination, ElCollapseItem, ElCollapse, ElAvatar, ElSkeleton },

    data() {
        return {
            loading:false,
            sources:[],
            packageservices:[],
            services:[],
            destinations:[],
            destinationtypes:[],
            form:{
                enq_date: moment(new Date()).format("YYYY-MM-DD"),
                type:'',
                name:'',
                email:'',
                mobile:'',
                enq_source:'',
                adults:'',
                childs:'',
                infants:'',
                budget:'',
                specific_requirements:'',
                package:{
                    source:'',
                    destinations:null,
                    departure_date:'',
                    return_date:'',
                    nights:'',
                    dest_team:'',
                    packageservices:[]
                },
                common:{
                    source:'',
                    destinations:null,
                    departure_date:'',
                    return_date:'',
                    nights:'',
                    dest_team:'',
                },
                flight:{
                    source:'',
                    destinations:null,
                    departure_date:'',
                    return_date:'',
                    dest_team:'',
                },
                visa:{
                    source:'',
                    destinations:null,
                    departure_date:'',
                    nights:'',
                    dest_team:'',
                }
            },
            rules:{
                name: [{ required: true, trigger: 'change', message:'Required' }],
                mobile: [{ required: true, trigger: 'change', message:'Required' }],
                email: [{ type: 'email', trigger: 'change', message:'Invalid E-mail ID' }],
                enq_source: [{ required: true, trigger: 'change', message:'Required' }],
                nights: [{ required: true, trigger: 'change', message:'Required' }],
                source: [{ required: true, trigger: 'change', message:'Required' }],
                departure_date: [{ required: true, trigger: 'change', message:'Required' }],
                adults: [{ required: true, trigger: 'change', message:'Required' }],
                destinations: [{ required: true, trigger: 'change', message:'Required' }],
                dest_team: [{ required: true, trigger: 'change', message:'Required' }],
                package:{
                    nights: [{ required: true, trigger: 'change', message:'Required' }],
                    source: [{ required: true, trigger: 'change', message:'Required' }],
                    departure_date: [{ required: true, trigger: 'change', message:'Required' }],
                    destinations: [{ required: true, trigger: 'change', message:'Required' }],
                    dest_team: [{ required: true, trigger: 'change', message:'Required' }],
                    packageservices: [{ required: true, trigger: 'change', message:'Required' }],
                },
                common:{
                    nights: [{ required: true, trigger: 'change', message:'Required' }],
                    source: [{ required: true, trigger: 'change', message:'Required' }],
                    departure_date: [{ required: true, trigger: 'change', message:'Required' }],
                    destinations: [{ required: true, trigger: 'change', message:'Required' }],
                    dest_team: [{ required: true, trigger: 'change', message:'Required' }],
                },
                flight:{

                    source: [{ required: true, trigger: 'change', message:'Required' }],
                    departure_date: [{ required: true, trigger: 'change', message:'Required' }],
                    destinations: [{ required: true, trigger: 'change', message:'Required' }],
                    dest_team: [{ required: true, trigger: 'change', message:'Required' }],
                },
                visa:{
                    nights: [{ required: true, trigger: 'change', message:'Required' }],
                    source: [{ required: true, trigger: 'change', message:'Required' }],
                    departure_date: [{ required: true, trigger: 'change', message:'Required' }],
                    destinations: [{ required: true, trigger: 'change', message:'Required' }],
                    dest_team: [{ required: true, trigger: 'change', message:'Required' }],
                }
            },
            ajax: {
                sourcesetting: {
                    ajax: {
                        url: '/api/getsources',
                        dataType: 'json',
                        delay: 250,
                        processResults: function (data) {
                            return {
                                results: $.map(data, function (item) {
                                    return {
                                        text: item.name,
                                        id: item.id
                                    }
                                })
                            };
                        },
                        cache: true
                    }
                },
                destinationsetting: {
                    ajax: {
                        url: '/api/getdestinations',
                        dataType: 'json',
                        delay: 250,
                        processResults: function (data) {
                            return {
                                results: $.map(data, function (item) {
                                    return {
                                        text: item.name,
                                        id: item.id
                                    }
                                })
                            };
                        },
                        cache: true
                    },
                    multiple:true,
                    tags:true
                }
            },
            alreadyexist:null,
            addedenquiry:null
        }
    },
    mounted() {
        this.getdata();
    },
    methods:{
        getdata(){
            this.loading=true;
            let currentObj = this;
            axios.post('/enquiry/addenquiry').then(function (response) {
                currentObj.services=response.data.services;
                currentObj.packageservices=response.data.packageservices;
                currentObj.sources=response.data.sources;
                currentObj.destinations=response.data.destinations;
                currentObj.destinationtypes=response.data.destinationtypes;
                currentObj.loading=false;
                currentObj.form.type=currentObj.services[0];

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        commonchange(){
            if(this.form.common.departure_date!="" && this.form.common.nights!=""){
                let start = moment(this.form.common.departure_date);
                this.form.common.return_date=start.add(this.form.common.nights, 'days').format("YYYY-MM-DD");
            }
            else{
                this.form.common.return_date='';
            }
        },
        packagechange(){
            if(this.form.package.departure_date!="" && this.form.package.nights!=""){
                let start = moment(this.form.package.departure_date);
                this.form.package.return_date=start.add(this.form.package.nights, 'days').format("YYYY-MM-DD");
            }
            else{
                this.form.package.return_date='';
            }
        },
        submitForm(){
            var formEl=this.$refs.ruleFormRef;
            let currentObj = this;
            this.addedenquiry=null;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    currentObj.loading=true;
                    axios.post('/enquiry', this.form).then(function (response) {
                        currentObj.addedenquiry=response.data.data;
                        currentObj.loading=false;
                        formEl.resetFields();
                    })
                        .catch(function (error) {
                            currentObj.loading=false;
                        });
                } else {

                    return false
                }
            })
        },
        checkexist() {

            let currentObj = this;
            this.alreadyexist=null;

                axios.post('/enquiry/checkexit', this.form).then(function (response) {
                    currentObj.alreadyexist=response.data;


                }).catch(function (error) {

                });


        },
        viewenquiry(link){

            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)
        },


    },
    watch: {

        'form.email'(newv,oldv) {
            this.checkexist();
        },
        'form.mobile'(newv,oldv) {
            this.checkexist();
        },
        'form.common.nights'(newv,oldv) {
            this.commonchange();
        },
        'form.common.departure_date'(newv,oldv) {
            this.commonchange();
        },
        'form.package.nights'(newv,oldv) {
            this.packagechange();
        },
        'form.package.departure_date'(newv,oldv) {
            this.packagechange();
        }
    }
}
</script>

<style scoped>

</style>
